import React from "react";
import { Route, Redirect } from "react-router-dom";
import * as CONFIG from "./pages/_config";
import ls from "local-storage";
import { toast } from "react-toastify";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const authLogin =
    ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`) === null ? false : true;
  if (!authLogin) toast.error("Please Login to access this page");

  return (
    <Route
      {...rest}
      render={(props) =>
        authLogin ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};
export default ProtectedRoute;
